"use client"
import { createContext } from "react"
import type { Locale } from "../types"

export const LocaleContext = createContext<Locale>("en-US")

export const LocaleProvider = LocaleContext.Provider
